import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from './Checkbox';
import { color } from '../../app/theme';
import Button from './Button';

const useStyles = makeStyles(
  {
    root: {
      padding: '24px  0',
      border: `1px solid ${color.$10}`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
    },
    title: {
      fontWeight: '400',
      fontSize: '15px',
      lineHeight: '15px',
      color: color.$13,
      marginBottom: 24,
      padding: '0 24px',
      textAlign: 'center',
    },
    conentTitle: {
      fontWeight: '500',
      fontSize: '17px',
      lineHeight: '17px',
      marginBottom: 12,
      color: color.$13,
      padding: '0 24px',
    },
    description: {
      minHeight: 'calc(100% - 194px)',
      maxHeight: 'calc(100% - 194px)',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: color.$12,
      overflowY: 'auto',
      padding: '0 24px 24px',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
    },
    hr: {
      margin: 0,
    },
    checkLabel: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$13,
    },
    checkFormControlLabel: {
      margin: '24px auto',
    },
  },
  {
    name: 'TermsPage',
  },
);

const TermsPage = ({
  data,
  isCheck = false,
  setIsCheck,
  onNext = () => {},
  disable = false,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { policy } = data || {};
  const {
    pageTitle,
    title: termsTitle,
    content: termsDescription,
    btnBgColor: termsBtnBackgroundColor,
  } = policy || {};

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {pageTitle || t('ecBinding:termsPage')}
      </div>
      <div className={classes.conentTitle}>{termsTitle}</div>
      <div className={classes.description}>{termsDescription}</div>
      <hr className={classes.hr} />
      <FormControlLabel
        className={classes.checkFormControlLabel}
        classes={{
          label: classes.checkLabel,
        }}
        control={
          <Checkbox
            checked={isCheck}
            onChange={() => {
              setIsCheck(!isCheck);
            }}
            name="checked"
            color="primary"
          />
        }
        label={t('ecBinding:termsPage-isCheck')}
      />
      <Button
        isDisable={!isCheck || disable}
        style={{
          margin: '0 24px',
          backgroundColor: termsBtnBackgroundColor || color.$1,
        }}
        topic="primaryGreen"
        onClick={() => {
          onNext();
        }}
      >
        {t('next')}
      </Button>
    </div>
  );
};

export default TermsPage;
